import { createContext, useContext } from 'react';

interface ActionListContextValue {
  testID?: string;
}

const ActionListContext = createContext<ActionListContextValue | undefined>(
  undefined
);

export const ActionListProvider = ActionListContext.Provider;

export const useActionListContext = () => {
  const context = useContext(ActionListContext);
  return context;
};
